<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useCatalogStore} from "@/stores/Training/Catalog";
import axios from "axios";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";

export default {
    name: "StrCatalogAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        disabled: Boolean,
        multiple: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const {priceFormat} = useSharedMethod();
        const {$i18n} = useTools();
        const catalogStore = useCatalogStore();

        const headers = [
            {
                text: $i18n.t("common.name"),
                align: "left",
                sortable: true,
                value: "name",
                width: "0%"
            },
            {
                text: $i18n.t("common.duration"),
                align: "left",
                sortable: true,
                value: "duration",
                width: "0%"
            },
            {
                text: $i18n.t("training.catalog_price"),
                align: "left",
                sortable: true,
                value: "price",
                width: "0%"
            },
            {
                text: $i18n.t("training.catalog_objective"),
                align: "left",
                sortable: true,
                value: "objective",
            },
        ];

        const catalog = ref(null);
        const dialog = ref(false);

        function findAll() {
            loading.value  = true;
            axios.get(`/catalogs`).then(response => {
                catalogStore.setCatalogs(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function dbClick(item) {
            input(item.id);
        }

        function input(value) {
            emit('input', value);
            dialog.value = false;
        }

        watch(() => props.value, () => {
            catalog.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            catalogStore,
            dialog,
            loading,
            inputColor,
            backgroundColor,
            headers,
            catalog,
            priceFormat,
            dbClick,
            input,
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            max-width="1200"
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('module.training_catalog')"/>
                <v-card-text>
                    <w-data-table
                        :headers="headers"
                        :items="catalogStore.catalogs"
                        :total="catalogStore.catalogs.length"
                        :loading="loading"
                        sort-by="name"
                        disable-pagination
                        @rowDbClick="dbClick"
                    >

                        <template v-slot:[`item.name`]="{ item }">
                            <w-inline-text bold :text="item.name"/>
                            <w-btn-icon-help :text="item.program"/>
                        </template>
                        <template v-slot:[`item.duration`]="{ item }">
                            <w-inline-text :text="`${item.duration} ${$t('training.catalog_days')}`"/>
                        </template>
                        <template v-slot:[`item.price`]="{ item }">
                            <w-inline-text :text="priceFormat(item.price)"/>
                        </template>
                        <template v-slot:[`item.objective`]="{ item }">
                            {{ item.objective }}
                        </template>
                    </w-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-autocomplete
                v-model="catalog"
                :items="catalogStore.catalogs"
                item-value="id"
                item-text="name"
                outlined
                dense
                :chips="multiple"
                :deletable-chips="!readonly"
                :label="label"
                :color="inputColor"
                :background-color="backgroundColor"
                :readonly="readonly"
                :disabled="disabled"
                :multiple="multiple"
                :loading="loading"
                :clearable="!readonly"
                @input="input"
                :append-outer-icon="readonly ? null : 'mdi-book-cog'"
                @click:append-outer="dialog = true"
                :rules="rules"
                hide-details="auto"
        />

        <input type="hidden">
    </div>
</template>